export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1 style={{ marginTop: "-100px" }}>BEMFIX</h1>
                <img src="" alt="" />
                <h3 style={{ color: "#fff" }}>
                  Rebitadores de Rosca Profissional.
                </h3>
                <h3 style={{ marginBottom: "100px", color: "#fff" }}>
                  Qualidade e Tecnologia 100% Nacional para redução de custos.
                </h3>
                <a
                  href="#contact"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Entre em contato
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
